import { Button, Divider, ListItemText, Menu, MenuItem, Stack, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useAppSelector } from '../../store/hooks';
import { useLogto } from '@logto/react';
import Avatar from 'boring-avatars';
import { getCurrentUrl } from '../../utils/string';
import { getUserDetails } from '../../store/user/userSlice';

const User: React.FC = () => {
	const userDetails = useAppSelector((state) => getUserDetails(state));
	const { signOut } = useLogto();

	const [anchor, setAnchor] = useState<null | HTMLElement>(null);
	const open = Boolean(anchor);

	const version = __APP_VERSION__;

	return (
		<>
			<Button
				data-testid="user-menu-button"
				sx={{ textTransform: 'none', padding: 1 }}
				disableRipple
				onClick={(e) => setAnchor(e.currentTarget)}
			>
				<Stack alignItems={'center'} spacing={1}>
					<Avatar name={userDetails.name} variant="beam" size="40px" aria-label="User Avatar" />
					<Typography data-testid="user-name-text" variant="body1" color={'text.primary'}>
						{userDetails.name}
					</Typography>
				</Stack>
			</Button>

			<Menu anchorEl={anchor} open={open} onClose={() => setAnchor(null)} disableScrollLock>
				<MenuItem disabled>{userDetails.email}</MenuItem>
				<Divider />
				<MenuItem disabled data-testid="user-orgs-text">
					<ListItemText
						primary="Organisations:"
						secondary={
							<Stack direction={'column'} component={'span'}>
								{userDetails.orgs.map((org) => {
									return (
										<React.Fragment key={`org-text-${org.name}`}>
											<Typography component={'span'} paddingLeft={1}>
												{`- ${org.name}`}
											</Typography>
											{org.roles.map((role) => {
												return (
													<Typography component={'span'} paddingLeft={5} key={`org-text-${org.name}-role-${role}`}>
														{`- ${role}`}
													</Typography>
												);
											})}
										</React.Fragment>
									);
								})}
							</Stack>
						}
					/>
				</MenuItem>
				<Divider />
				<MenuItem disabled data-testid="version-display">
					{`Prometheus Version ${version}`}
				</MenuItem>
				<Divider />
				<MenuItem
					onClick={() => {
						signOut(getCurrentUrl());
					}}
				>
					Sign Out
				</MenuItem>
			</Menu>
		</>
	);
};

export default User;
